import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Betcris_Title } from '../../../../../utils/ES/Modals/PostModals';

const ModalPostBetcris = () => {
  return (
    <>
      <ModalVideo
        id="betcris-post"
        dataText={Betcris_Title}
        videoSrc="https://player.vimeo.com/video/384591943?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_BETCRIS"
      />
    </>
  );
};

export default ModalPostBetcris;
